import { IPagination } from '../../../types/pagination'
import * as constants from '../actions/constants'
import { RolesActions } from '../actions/roleActions'
import { IRight } from '../types/right'
import { IRole } from '../types/role'


export const _initialRole: IRole = {
  id: '',
  name: '',
  default: false,
  rights: [] as IRight[],
  employees_count: 0
}

const initialDepartmentsPagination: IPagination<IRole[]> = {
  links: { next: '', previous: '' },
  count: 0,
  current_page: 0,
  total_pages: 0,
  results: [_initialRole],
  page_size: 5,
  last_page: 0,
  to: 0,
  from: 0
}

export const initialRoles: IRole[] = [_initialRole]

export const roles = (state: IRole[] = initialRoles, action: RolesActions): IRole[] => {
  switch (action.type) {
    case constants.GET_ROLES_SUCCESS:
      return action.roles

    case constants.UPDATE_ROLE_SUCCESS:
      return state.map(role => {
        if (role.id === action.role.id) {
          return action.role
        }
        return role
      })

    case constants.CREATE_ROLE_SUCCESS:
     return [...state, action.role]

    case constants.DELETE_ROLE_SUCCESS:
        return state.filter(role => role.id !== action.role.id)

    default:
      return state
  }
}

export const sortRoles = (state: { name: string, direction: string} = { name: '', direction: ''}, action: RolesActions): { name: string, direction: string } => {
  switch (action.type) {
    case constants.SORT_ROLES:
      return action.sort

    default:
      return state
  }
}

export const selectedRole = (state = _initialRole , action: RolesActions): IRole => {
  switch (action.type) {
    case constants.SELECT_ROLE:
    case constants.CREATE_ROLE_SUCCESS:
    case constants.UPDATE_ROLE_SUCCESS:
      return action.role

    default:
      return state
  }
}

export const openRolForm = (state = false, action: RolesActions): boolean => {
  switch (action.type) {
    case constants.OPEN_ROLE_FORM:
      return action.open
    case constants.CREATE_ROLE_SUCCESS:
    case constants.UPDATE_ROLE_SUCCESS:
      return false

    default:
      return state
  }
}

export const roleActivePage = (state = 1, action: RolesActions): number => {
  switch (action.type) {
    case constants.SET_ROLE_ACTIVE_PAGE:
      return action.page

    default:
      return state
  }
}

export const filterRoles = (state = '', action: RolesActions): string => {
  switch (action.type) {
    case constants.FILTER_ROLES:
      return action.search

    default:
      return state
  }
}

export const rolesPagination = (state: IPagination<IRole[]> = initialDepartmentsPagination, action: RolesActions): IPagination<IRole[]> => {
  switch (action.type) {
    case constants.GET_PAGINATED_ROLES_SUCCESS:
      return action.roles

    default:
      return state
  }
}


export const rights = (state: IRight[] = [], action: RolesActions): IRight[] => {
  switch (action.type) {
    case constants.GET_RIGHTS_SUCCESS:
      return action.rights.map(r => {
        const _title = r.name.split('_');
        for (let i = 0; i < _title.length; i++) {
          _title[i] = _title[i][0].toUpperCase() + _title[i].substr(1)
          if (_title[i] === 'Of') {
            _title[i] = _title[i].toLowerCase()
          }
        }

        return {...r, title: _title.join(' ')}
      })

    default:
      return state
  }
}
